/**
 * Created by asiulik on 15.05.2018.
 */

define(function(){

    return {
        parketfinderSelector: "#parketfinder",
        filterSideNavTriggerSelector: "#filterSideNavTriggerSelector",
        filtersNavigation: "#filters__nav",
        filtersContainerSelector: "#parketFinderFilters",
        contentContainerSelector: "#parketFinderContent",
        filtersLinkSelector: '[data-parketfinder-link]',
        finderPendingActiveClass: "parketfinder--pending",
        preloaderSelector: ".finder__content__preloader",
        searchItemsSelector: "[data-parketfinder-searchquery]"
    }

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/parketFilters/parketFiltersConfig.js